import { combineReducers } from '@reduxjs/toolkit';
import fuse from './fuse';
import i18n from './i18nSlice';
import user from './userSlice';
// eslint-disable-next-line import/extensions
import meta from './reducers/meta';
// eslint-disable-next-line import/extensions
import command from './reducers/requestCommandTabSlice';
// eslint-disable-next-line import/extensions
import commandList from './reducers/requestCommondListSlice';
// eslint-disable-next-line import/extensions
import commandGetId from './reducers/requestCommondId';
// eslint-disable-next-line import/extensions
import filePreview from './reducers/filePreviewSlice';
// eslint-disable-next-line import/extensions
import fileDownload from './reducers/docFIleDownloadSlice';
// eslint-disable-next-line import/extensions
import commandHistory from './reducers/requestCommandHistory';
// eslint-disable-next-line import/extensions
import usersListCommand from './reducers/requestUsersList';
// eslint-disable-next-line import/extensions
import internalGroup from './reducers/internalGroupListSlice';
// eslint-disable-next-line import/extensions
import office from './reducers/officeUrlSlice';
// eslint-disable-next-line import/extensions
import getAccess from './reducers/reauestGetAccessSlice';
// eslint-disable-next-line import/extensions
import positiveConclusion from './reducers/givePositiveConclusionSlice';
// eslint-disable-next-line import/extensions
import negativeConclusion from './reducers/giveNegativeConclusionSlice';
// eslint-disable-next-line import/extensions
import appealsTab from './reducers/appeals/appealsTabs';
// eslint-disable-next-line import/extensions
import appealsList from './reducers/appeals/appealsList';
// eslint-disable-next-line import/extensions
import appealGetId from './reducers/appeals/appealGetId';
// eslint-disable-next-line import/extensions
import claimsTab from './reducers/claim/claimsTabs';
// eslint-disable-next-line import/extensions
import claimsList from './reducers/claim/claimList';
// eslint-disable-next-line import/extensions
import claimGetId from './reducers/claim/claimGetId';
// eslint-disable-next-line import/extensions
import lawSuitList from './reducers/law-suit/lawSuitList';
// eslint-disable-next-line import/extensions
import lawSuitTab from './reducers/law-suit/lawSuitTabs';
// eslint-disable-next-line import/extensions
import lawSuitGetId from './reducers/law-suit/lawSuitGetId';
// eslint-disable-next-line import/extensions
import protestGetId from './reducers/protest/protestGetId';
// eslint-disable-next-line import/extensions
import protestList from './reducers/protest/protestList';
// eslint-disable-next-line import/extensions
import protestTab from './reducers/protest/protestTabs';
// eslint-disable-next-line import/extensions
import statusWebsocket from './reducers/websocketSlice';
// eslint-disable-next-line import/extensions
import getTemplateList from './reducers/offer/getTemplateListSlice';
// eslint-disable-next-line import/extensions
import generateFile from './reducers/offer/generateFileSlice';
// eslint-disable-next-line import/extensions
import uploadFile from './reducers/uploadFileSlice';
// eslint-disable-next-line import/extensions
import organizationsList from './reducers/offer/organizationsListSlice';
// eslint-disable-next-line import/extensions
import generateTemplate from './reducers/offer/genereteTemplate';
// eslint-disable-next-line import/extensions
import offerTab from './reducers/offer/offerTabsSlice';
// eslint-disable-next-line import/extensions
import createOffer from './reducers/offer/createOfferSlice';
// eslint-disable-next-line import/extensions
import offerList from './reducers/offer/getOfferListSlice';
// eslint-disable-next-line import/extensions
import getOfferById from './reducers/offer/getOfferById';
// eslint-disable-next-line import/extensions
import isChief from './reducers/chiefStatus';
// eslint-disable-next-line import/extensions
import orgListSidePanel from './reducers/OrgListSidePanelSlice';
// eslint-disable-next-line import/extensions
import prefixList from './reducers/prefixListSlice';
// eslint-disable-next-line import/extensions
import orgListCountBy from './reducers/orgListCountBySlice';
// eslint-disable-next-line import/extensions
import homePageCount from './reducers/homePageCountSlice';
// eslint-disable-next-line import/extensions
import orgListRequest from './reducers/orgListRequest';
// eslint-disable-next-line import/extensions
import homeStatisticsByDate from './reducers/homeStatisticsByDate';
// eslint-disable-next-line import/extensions
import orgListLawSuit from './reducers/law-suit/orgListLawSuit';
// eslint-disable-next-line import/extensions
import getStatisticsByOrg from './reducers/getStatisticsByOrg';
// eslint-disable-next-line import/extensions
import getStatisticsByLawyer from './reducers/getStatisticsByLawyer';
// eslint-disable-next-line import/extensions
import orgListAppeal from './reducers/appeals/appealOrgList';
// eslint-disable-next-line import/extensions
import agreementList from './reducers/agrementList';
import orgList from './reducers/tool/org-list.slice';
import orgSearchList from './reducers/tool/org-search-list.slice';
import integrationsPersonInfos from './reducers/integrations/person-infos.slice';
import integrationsDiplomaInfos from './reducers/integrations/diploma-infos.slice';
import integrationsWorkHistory from './reducers/integrations/wor-history.slice';
import dynamicFormFields from './reducers/dynamicFormFieldsSlice';

const createReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    fuse,
    i18n,
    user,
    ...asyncReducers,
    meta,
    command,
    commandList,
    commandGetId,
    filePreview,
    fileDownload,
    commandHistory,
    usersListCommand,
    internalGroup,
    office,
    getAccess,
    positiveConclusion,
    negativeConclusion,
    appealsTab,
    appealsList,
    appealGetId,
    claimsTab,
    claimsList,
    claimGetId,
    lawSuitList,
    lawSuitTab,
    lawSuitGetId,
    protestGetId,
    protestList,
    protestTab,
    statusWebsocket,
    getTemplateList,
    generateFile,
    uploadFile,
    organizationsList,
    generateTemplate,
    offerTab,
    createOffer,
    offerList,
    getOfferById,
    isChief,
    orgListSidePanel,
    prefixList,
    orgListCountBy,
    homePageCount,
    orgListRequest,
    homeStatisticsByDate,
    orgListLawSuit,
    getStatisticsByOrg,
    getStatisticsByLawyer,
    orgListAppeal,
    agreementList,
    orgList,
    orgSearchList,
    integrationsPersonInfos,
    integrationsDiplomaInfos,
    integrationsWorkHistory,
    dynamicFormFields,
  });

  /*
	Reset the redux store when user logged out
	 */
  if (action.type === 'user/userLoggedOut') {
    // state = undefined;
  }

  return combinedReducer(state, action);
};

export default createReducer;
// export type RootReducer = ReturnType<typeof createReducer>;
